import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./PersonalInfo'));

function LoadablePersonalInfo() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadablePersonalInfo;
